import { render, staticRenderFns } from "./PageUserIns.vue?vue&type=template&id=6554881d&scoped=true&"
import script from "./PageUserIns.vue?vue&type=script&lang=js&"
export * from "./PageUserIns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6554881d",
  null
  
)

export default component.exports